export class UserApp {
  Id = 0;
  Name = '';
  Email = '';
  CompanyId = 0;
  Token = '';
  RefreshToken = '';
  TokenExpiration: string | null = null;
  PerfilCompleto = false;
  EsCabana = false;
  EsProductor = false;
  Ubicacion = '';
  InteresAsociarse = false;
  Telefono = '';
  ContactoNombreEmpresa = '';
  AvatarCode = '';
  AvatarUrl = '';
  Roles: string[] = [];
}
